// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-ellipsis-limit-text[data-v-fb0a0e26]{word-break:break-all}\n", ""]);
// Exports
module.exports = exports;
